import { PutMethod } from "../../methods/PutMethod";

export class SignUndoChecklistEndpoint extends PutMethod<undefined> {
  constructor() {
    super(`${process.env.REACT_APP_API_URL}/checklists/accept-undo`);
  }
}
